export const VIDEO_MAIN_EVENTS_SEARCH_AVAILABLE_MEDIA = 'VIDEO_SEARCH_AVAILABLE_MEDIA';
export const VIDEO_MAIN_EVENTS_SEARCH_AVAILABLE_MEDIA_RESPONSE = 'VIDEO_MAIN_EVENTS_SEARCH_AVAILABLE_MEDIA_RESPONSE';
export const VIDEO_MAIN_EVENTS_UPDATE_EVENT = 'VIDEO_MAIN_EVENTS_UPDATE_EVENT';
export const VIDEO_MAIN_EVENTS_RESTORE_AVAILABLE_MEDIA = 'VIDEO_MAIN_EVENTS_RESTORE_AVAILABLE_MEDIA';
export const VIDEO_MAIN_EVENTS_RESTORE_AVAILABLE_MEDIA_RESPONSE = 'VIDEO_MAIN_EVENTS_RESTORE_AVAILABLE_MEDIA_RESPONSE';
export const VIDEO_MAIN_EVENTS_OPEN_MODAL_ADD_NOTES = 'VIDEO_MAIN_EVENTS_OPEN_MODAL_ADD_NOTES';
